// extracted by mini-css-extract-plugin
export default {"blogContent":"VFV9zlDSim0qQYcWZPpG"};